module.exports = __webpack_public_path__ + "static/media/NaharLogo.83fc021c.png";